export const fundingtype = [
  'SAFE', 'Priced Round', 'Convertible Note', 'Credit'
]

export default fundingtype
